import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import { AuthContext } from '../../context/AuthContext';
import { DespesasFotografoContext } from '../../context/DespesasFotografoContext';
import { DespesasFotografoType, CreateDespesasFotografoType, UpdateDespesasFotografoType } from '../../context/hooks/useDespesasFotografo';
import useUser from '../../context/hooks/useUser';

const DespesasFotografo = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listDespesasFotografo, despesasFotografoPageCount, getAllDespesasFotografoPaged, createDespesasFotografo, updateDespesasFotografo, deleteDespesasFotografo, aprovarDespesasFotografo, rejeitarDespesasFotografo } = useContext(DespesasFotografoContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [newDespesasFotografo, setNewDespesasFotografo] = useState<CreateDespesasFotografoType>({
        description: "",
        value: 0,
        date: "",
        observation: "",
        empresaId: objUserTk.EmpresaId,
        vendedorId: 0,
        tipoDespesasFotografoId: 0
    });
    const [editingDespesasFotografo, setEditingDespesasFotografo] = useState<UpdateDespesasFotografoType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        description: '',
    });
    const [dataSearch, setDataSearch] = useState({ description: '' });

    useEffect(() => {
        setLoading(true);
        getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar despesas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllDespesasFotografoPaged(value, 9, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ description: '' });
        setLoading(true);
        getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewDespesasFotografo(prevDespesasFotografo => ({
            ...prevDespesasFotografo,
            [name]: value === '' ? null : value
        }));
    };

    const handleCreateDespesasFotografo = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const payload = {
            ...newDespesasFotografo,
            description: newDespesasFotografo.description,
            value: Number(newDespesasFotografo.value),
            date: newDespesasFotografo.date,
            observation: newDespesasFotografo.observation,
            empresaId: Number(objUserTk.EmpresaId),
            vendedorId: Number(newDespesasFotografo.vendedorId),
        };

        createDespesasFotografo(payload)
            .then(createdDespesasFotografo => {
                if (createdDespesasFotografo) {
                    setCreateModalOpen(false);
                    setNewDespesasFotografo({
                        description: "",
                        value: 0,
                        date: "",
                        observation: "",
                        empresaId: objUserTk.EmpresaId,
                        vendedorId: 0
                    });
                    getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId);
                } else {
                    console.error("Erro ao criar despesa.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar despesa:", error);
            });
    };

    const handleEditDespesasFotografo = (despesasFotografo: DespesasFotografoType) => {
        setEditingDespesasFotografo(despesasFotografo);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingDespesasFotografo) {
            const updatedData = {
                ...editingDespesasFotografo,
            };
            updateDespesasFotografo(updatedData)
                .then(updatedDespesasFotografo => {
                    if (updatedDespesasFotografo) {
                        setEditModalOpen(false);
                        getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId);
                        setEditingDespesasFotografo(null);
                    } else {
                        console.error("Erro ao atualizar despesa.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar despesa:", error);
                });
        }
    };

    const handleDeleteDespesasFotografo = (despesasFotografoId: number) => {
        if (window.confirm("Tem certeza que deseja excluir esta despesa?")) {
            deleteDespesasFotografo(despesasFotografoId)
                .then(deletedDespesasFotografo => {
                    if (deletedDespesasFotografo) {
                        getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir despesa.");
                    }
                    getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir despesa:", error);
                });
        }
    };

    const getDespesasStatusLabel = (status: number) => {
        switch (status) {
            case 0:
                return "Pendente";
            case 1:
                return "Aprovada";
            case 2:
                return "Rejeitada";
            case 3:
                return "Cancelada";
            default:
                return "Desconhecido";
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Despesas dos vendedores"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Descrição</th>
                                        <th>Valores</th>
                                        <th>Data</th>
                                        <th>Status</th>
                                        <th>Categoria</th>
                                        <th>Fotógrafo</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listDespesasFotografo.map((despesasFotografo: DespesasFotografoType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{despesasFotografo.id}</td>
                                                <td>{despesasFotografo.description}</td>
                                                <td>{(despesasFotografo?.value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{despesasFotografo.date ? new Intl.DateTimeFormat('pt-BR').format(new Date(despesasFotografo.date)) : ""}</td>
                                                <td>
                                                    <span className={`badge ${despesasFotografo.status === 0 ? "bg-warning text-white" :
                                                        despesasFotografo.status === 1 ? "bg-success text-white" :
                                                            despesasFotografo.status === 2 ? "bg-danger text-white" :
                                                                "bg-secondary text-white"
                                                        }`}>
                                                        {getDespesasStatusLabel(Number(despesasFotografo.status))}
                                                    </span>
                                                </td>
                                                <td>{despesasFotografo.tipoDespesasFotografoName ?? "-"}</td>
                                                <td>{despesasFotografo.vendedorName ?? "-"}</td>
                                                <td>
                                                    <Button
                                                        color="success"
                                                        size="sm"
                                                        title="Aprovar"
                                                        onClick={() => {
                                                            aprovarDespesasFotografo(despesasFotografo.id)
                                                                .then(success => {
                                                                    if (success) {
                                                                        getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId);
                                                                    } else {
                                                                        console.error("Erro ao aprovar tarefa.");
                                                                    }
                                                                })
                                                                .catch(error => console.error("Erro ao aprovar tarefa:", error));
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-thumbs-up me-1"></i> Aprovar
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        title="Rejeitar"
                                                        onClick={() => {
                                                            rejeitarDespesasFotografo(despesasFotografo.id)
                                                                .then(success => {
                                                                    if (success) {
                                                                        getAllDespesasFotografoPaged(1, 9, objUserTk.EmpresaId);
                                                                    } else {
                                                                        console.error("Erro ao rejeitar tarefa.");
                                                                    }
                                                                })
                                                                .catch(error => console.error("Erro ao rejeitar tarefa:", error));
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-thumbs-down me-1"></i> Rejeitar
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {despesasFotografoPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={despesasFotografoPageCount}
                                        />
                                    </div>
                                )}
                                {listDespesasFotografo.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as despesas.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>
        </>
    );
};

export default DespesasFotografo;